import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating a view
import Filter from 'views/reports/assignmentQuotaMade/filter'; // Importing Filter component for report filtering
import Table from 'views/reports/assignmentQuotaMade/table'; // Importing Table component for displaying report data
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the assignment quota view.
 * @extends JetView
 */
export default class assignmentQuotaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Get the current theme configuration
        const theme = this.app.config.theme;
        // Get the current screen size configuration
        const screen = this.app.config.size;
        // Define the right panel configuration
        const right = {
            type: 'wide',
            rows: [],
        };
        // Define the toolbar configuration
        const toolbar = {
            view: 'toolbar', // Specify the view type as 'toolbar'
            id: 'toolbar', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Define the columns within the toolbar
                {
                    view: 'select', // Dropdown selection for page size
                    options: ['10', '20', '50', '100', '1000', '10000'], // Options for selection
                    width: 70, // Width of the select element
                    on: {
                        // Event handler for when the selection changes
                        onChange: function () {
                            // Update the pager size based on the selected value
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Convert selected value to number
                           $$('datatable').refresh(); // Refresh the datatable to reflect changes
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false, // Disable automatic sizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
                {
                    view: 'richselect', // Rich select for export options
                    name: 'Export', // Name of the select element
                    id: 'Export', // Unique identifier for the rich select
                    width: 120, // Width of the rich select
                    placeholder: _('Exportar'), // Placeholder text for the select
                    options: [
                        // Options for export format
                        { id: '1', value: 'Excel' }, // Option for Excel export
                        { id: '2', value: 'PDF' }, // Option for PDF export
                    ],
                    on: {
                        // Event handler for when the export selection changes
                        onChange: function (value) {
                            // Check if the selected value is for Excel export
                            if (value == 1) {
                                var table =$$('datatable'); // Reference to the datatable
                                // Loop through columns to remove format for export
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for exportable columns
                                    }
                                }
                                // Trigger export event with report details
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de transferencias de saldo Realizadas'),
                                        TypeReport: 'Excel', // Specify report type as Excel
                                    },
                                ]);
                                // Export the datatable to Excel
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de transferencias de saldo Realizadas'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                // Check if the selected value is for PDF export
                                if (value == 2) {
                                    // Trigger export event with report details
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reporte de transferencias de saldo Realizadas'),
                                            TypeReport: 'PDF', // Specify report type as PDF
                                        },
                                    ]);
                                    // Export the datatable to PDF
                                    webix.toPDF($$('datatable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de transferencias de saldo Realizadas'),
                                        autowidth: true, // Enable automatic width adjustment
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            // Reset the export selection value
                           $$('Export').setValue('');
                        }.bind(this), // Bind the context to the event handler
                    },
                },
            ],
        };
        /**
         * Toolbar configuration object for exporting data.
         * @type {Object}
         */
        const toolbar2 = {
            view: 'toolbar', // Defines the view type as a toolbar
            id: 'toolbar2', // Unique identifier for the toolbar
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                // Array of column configurations within the toolbar
                {},
                {
                    view: 'richselect', // Dropdown selection for export options
                    name: 'Export', // Name of the select input
                    id: 'Export2', // Unique identifier for the select input
                    width: 120, // Width of the select input
                    placeholder: _('Exportar'), // Placeholder text for the select input
                    options: [
                        // Options for the dropdown
                        { id: '1', value: 'Excel' }, // Option for exporting to Excel
                        { id: '2', value: 'PDF' }, // Option for exporting to PDF
                    ],
                    on: {
                        // Event handlers for the richselect
                        onChange: function (value) {
                            // Triggered when the selected value changes
                            if (value == 1) {
                                // Check if the selected value is for Excel export
                                var table =$$('treetable'); // Get the reference to the tree table
                                for (
                                    // Iterate through the columns of the table
                                    var j = 0;
                                    j < table.config.columns.length;
                                    j++
                                ) {
                                    if (table.config.columns[j].exportType) {
                                        // Check if the column has an export type
                                        delete table.config.columns[j].format; // Remove the format for export
                                    }
                                }
                                // Trigger an event for exporting data with report details
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de transferencias de saldo Realizadas'),
                                        TypeReport: 'Excel', // Specify the report type as Excel
                                    },
                                ]);
                                // Export the table data to an Excel file
                                webix.toExcel(table, {
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Reporte de transferencias de saldo Realizadas'),
                                    footer: false, // Do not include footer in the export
                                });
                            } else {
                                if (value == 2) {
                                    // Check if the selected value is for PDF export
                                    // Trigger an event for exporting data with report details
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                                _('Reporte de transferencias de saldo Realizadas'),
                                            TypeReport: 'PDf', // Specify the report type as PDF
                                        },
                                    ]);
                                    // Export the table data to a PDF file
                                    webix.toPDF($$('treetable'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('treetable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Reporte de transferencias de saldo Realizadas'),
                                        autowidth: true, // Automatically adjust width for the PDF
                                        footer: false, // Do not include footer in the export
                                    });
                                }
                            }
                           $$('Export2').setValue(''); // Reset the select input value after export
                        }.bind(this), // Bind the context to the function
                    },
                },
            ],
        };
        const left = {
            /**
             * CSS class for the left panel.
             * @type {string}
             */
            css: 'int-left',

            /**
             * Array of rows to be displayed in the left panel.
             * @type {Array<Object>}
             */
            rows: [
                {
                    /**
                     * View type for the toolbar.
                     * @type {string}
                     */
                    view: 'toolbar',

                    /**
                     * CSS theme applied to the toolbar.
                     * @type {string}
                     */
                    css: theme,

                    /**
                     * Elements contained within the toolbar.
                     * @type {Array<Object>}
                     */
                    elements: [
                        {
                            /**
                             * View type for the label.
                             * @type {string}
                             */
                            view: 'label',

                            /**
                             * Label text based on screen size.
                             * @type {string}
                             */
                            label:
                                screen == 'small'
                                    ? _('Transferencias realizadas') // Label for small screens
                                    : _(
                                          'Reporte de transferencias de saldo Realizadas', // Label for larger screens
                                      ),
                        },
                        {
                            /**
                             * Type of the button container.
                             * @type {string}
                             */
                            type: 'wide',

                            /**
                             * CSS class for styling the button container.
                             * @type {string}
                             */
                            css: 'close-bottom',

                            /**
                             * Unique identifier for the search button.
                             * @type {string}
                             */
                            id: 'button-search',

                            /**
                             * Columns contained within the button container.
                             * @type {Array<Object>}
                             */
                            cols: [
                                {
                                    /**
                                     * View type for the icon.
                                     * @type {string}
                                     */
                                    view: 'icon',

                                    /**
                                     * Icon class for the search icon.
                                     * @type {string}
                                     */
                                    icon: 'wxi-search',

                                    /**
                                     * Bottom margin for the icon.
                                     * @type {number}
                                     */
                                    bottom: 20,

                                    /**
                                     * Right margin for the icon.
                                     * @type {number}
                                     */
                                    right: 35,

                                    /**
                                     * Width of the icon.
                                     * @type {number}
                                     */
                                    width: 30,

                                    /**
                                     * Height of the icon.
                                     * @type {number}
                                     */
                                    height: 30,

                                    /**
                                     * Click event handler for the icon.
                                     * @function
                                     */
                                    click: () => {
                                       $$('filterPopup').show(); // Show the filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            /**
                             * Type of the button container.
                             * @type {string}
                             */
                            type: 'wide',

                            /**
                             * CSS class for styling the button container.
                             * @type {string}
                             */
                            css: 'close-bottom',

                            /**
                             * Columns contained within the button container.
                             * @type {Array<Object>}
                             */
                            cols: [
                                {
                                    /**
                                     * View type for the icon.
                                     * @type {string}
                                     */
                                    view: 'icon',

                                    /**
                                     * Icon class for the close icon.
                                     * @type {string}
                                     */
                                    icon: 'wxi-close',

                                    /**
                                     * Bottom margin for the icon.
                                     * @type {number}
                                     */
                                    bottom: 20,

                                    /**
                                     * Right margin for the icon.
                                     * @type {number}
                                     */
                                    right: 35,

                                    /**
                                     * Width of the icon.
                                     * @type {number}
                                     */
                                    width: 30,

                                    /**
                                     * Height of the icon.
                                     * @type {number}
                                     */
                                    height: 29,

                                    /**
                                     * Click event handler for the icon.
                                     * @function
                                     */
                                    click: () => this.show('/top/dashboard'), // Navigate to the dashboard on click
                                },
                            ],
                        },
                    ],
                },
                Filter, // Reference to the Filter component
                Table, // Reference to the Table component
                toolbar, // Reference to the first toolbar component
                toolbar2, // Reference to the second toolbar component
            ],
        };
        // Initialize the Webix UI in full-screen mode
        webix.ui.fullScreen();

        // Return an object representing a Webix form configuration
        return {
            // Unique identifier for the form
            id: 'a5',

            // Type of the form layout
            type: 'clean',

            // View type of the component
            view: 'form',

            // Enable vertical scrolling for the form
            scroll: 'y',

            // Define the rows within the form
            rows: [
                {
                    // Responsive design identifier for the row
                    responsive: 'a5',

                    // Type of the row layout
                    type: 'wide',

                    // Define the columns within the row
                    cols: [left],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * This method is called after the view is created.
     */
    init() {
        // Waits for the Webix library to be ready before executing the function
        webix.ready(function () {
            // Checks if the screen width or height is less than 500 pixels
            if (screen.width < 500 || screen.height < 500) {
                // Retrieves child views of the 'toolbar' component
                var childs =$$('toolbar').getChildViews();
                // Removes the third child view from the 'toolbar'
               $$('toolbar').removeView(childs[2]);
                // Defines the 'group' property of 'pagerA' to 1
               $$('pagerA').define('group', 1);
            }
            // Checks if the screen width and height are greater than 500 pixels
            if (screen.width > 500 && screen.height > 500) {
                // Hides the 'button-search' component
               $$('button-search').hide();
            }
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
